module.exports = __webpack_public_path__ + "img/macbook_charge.f2bdd537.png";